import * as Sentry from '@sentry/react';

import { setOrigin } from './originStorage';

/**
 * Extracts specified SSO parameters from a URL, stores them in localStorage,
 * and returns the modified URL.
 *
 * @param {string} inputUrl - The input URL containing potential SSO query parameters.
 * @example
 * const modifiedUrl = extractSsoParams('http://example.com?token=abc123&network=mynetwork');
 * // modifiedUrl: "http://example.com/"
 *
 */

// @TODO: Remove this once we have removed the deprecated SSO params from token urls. https://dev.azure.com/emboldhealth/engineering/_workitems/edit/18638
export const deprecatedSsoParams = ['network', 'network_group', 'zipcode'];

export default function extractSsoParams(inputUrl: string): string {
  const url = new URL(inputUrl);
  const params = url.searchParams;
  const token = params.get('token');

  for (const deprecatedParam of deprecatedSsoParams) {
    if (params.has(deprecatedParam)) {
      params.delete(deprecatedParam);
    }
  }

  if (params.has('token') && token) {
    localStorage.setItem('integrationToken', token);
    Sentry.addBreadcrumb({
      category: 'auth',
      message: 'Set integration token in storage from query parameter',
      level: 'info',
    });
    params.delete('token');
  }

  if (params.has('origin')) {
    const origin = params.get('origin');
    if (origin) {
      setOrigin(origin);
      params.delete('origin');
    }
  }

  return url.toString();
}
